import React from 'react';
import { Chip, Tooltip } from '@mui/material';
import CakeIcon from '@mui/icons-material/Cake';
import { useTranslation } from 'react-i18next';

export const computeAgeAtDate = (dateNaissance, targetDate) => {
  if (!dateNaissance || !targetDate) return null;
  const dob = new Date(dateNaissance);
  const target = new Date(targetDate);
  if (isNaN(dob) || isNaN(target)) return null;
  const diffMs = target - dob;
  if (diffMs < 0) return null;
  const totalDays = diffMs / (1000 * 60 * 60 * 24);
  const years = Math.floor(totalDays / 365.25);
  const anniversaryThisYear = new Date(dob);
  anniversaryThisYear.setFullYear(dob.getFullYear() + years);
  const remainingMs = target - anniversaryThisYear;
  const months = Math.max(0, Math.floor(remainingMs / (1000 * 60 * 60 * 24 * 30.44)));
  const decimal = (totalDays / 365.25).toFixed(1);
  return { years, months, decimal };
};

const AgeAtInformeChip = ({ dateNaissance, informeDate, size = 'small' }) => {
  const { t } = useTranslation();
  const age = computeAgeAtDate(dateNaissance, informeDate);
  if (!age) return null;

  const label = t('ageAtInforme.atAge', { age: age.decimal, defaultValue: `${age.decimal} ans` });
  const tooltipText = t('ageAtInforme.tooltip', {
    years: age.years,
    months: age.months,
    defaultValue: `Le joueur avait ${age.years} ans et ${age.months} mois lors du rapport`,
  });

  return (
    <Tooltip title={tooltipText} arrow>
      <Chip
        icon={<CakeIcon sx={{ color: '#6a4fa3 !important' }} />}
        label={label}
        size={size}
        sx={{
          backgroundColor: '#ede7f6',
          color: '#4527a0',
          fontWeight: 600,
          height: 22,
          '& .MuiChip-label': { px: 0.75, fontSize: '0.72rem' },
          '& .MuiChip-icon': { ml: 0.5, fontSize: 11 },
        }}
      />
    </Tooltip>
  );
};

export default AgeAtInformeChip;
